import * as core from '@actimi/core-migration';

export default async function getActimiCoreLazy() {
  return import('@actimi/core-migration');
}

export const useActimiCoreAPI = (): typeof core => {
  return core;
};
